<div class="w3-display-middle">
    <h1 class="w3-jumbo w3-animate-top w3-center"><code>Acceso denegado 🚫🚫🚫🚫</code></h1>
    <hr class="w3-border-white w3-animate-left">
    <h3 class="w3-center w3-animate-right" >No posee autorización para ingresar a esta página.</h3>
    <h6 class="w3-center w3-animate-zoom"><strong>Codigo de error</strong>: 403 forbidden</h6>
  </div>